import * as TYPE from './actionTypes'

export const setLanguage = (language) => ({
  type: TYPE.SET_LANGUAGE,
  language,
})
